var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5550_16639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4.58325C2.41421 4.58325 2.75 4.91904 2.75 5.33325V13.2499H13.25V5.33325C13.25 4.91904 13.5858 4.58325 14 4.58325C14.4142 4.58325 14.75 4.91904 14.75 5.33325V13.9999C14.75 14.4141 14.4142 14.7499 14 14.7499H2C1.58579 14.7499 1.25 14.4141 1.25 13.9999V5.33325C1.25 4.91904 1.58579 4.58325 2 4.58325Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0830078 2C-0.0830078 1.58579 0.252779 1.25 0.666992 1.25H15.3337C15.7479 1.25 16.0837 1.58579 16.0837 2V5.33333C16.0837 5.74755 15.7479 6.08333 15.3337 6.08333H0.666992C0.252779 6.08333 -0.0830078 5.74755 -0.0830078 5.33333V2ZM1.41699 2.75V4.58333H14.5837V2.75H1.41699Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91699 8C5.91699 7.58579 6.25278 7.25 6.66699 7.25H9.33366C9.74787 7.25 10.0837 7.58579 10.0837 8C10.0837 8.41421 9.74787 8.75 9.33366 8.75H6.66699C6.25278 8.75 5.91699 8.41421 5.91699 8Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5550_16639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.590ade51dd160ee2572e4b21e14dc512.svg";
export { ForwardRef as ReactComponent };